import React from "react";
import * as Icons from "lucide-react";
import { CheckCircle2, MessageCircle, Send } from "lucide-react";
import { BUILD_SERVICES, BUILD_WHY, BRAND, waLink } from "../mock";

export default function BuildSoftware() {
  const msg = "Hi, I'm interested in getting a custom trading software built";
  return (
    <section id="build" className="py-24 bg-[#070d19] border-y border-[rgba(46,155,255,0.1)]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center reveal">
          <span className="text-[12px] tracking-[0.25em] text-[#2e9bff] font-semibold">SOFTWARE DEVELOPMENT COMPANY</span>
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-white mt-4">We Build Your <span className="text-blue-grad">Dream Trading Software</span></h2>
          <p className="text-slate-400 mt-4 max-w-3xl mx-auto">THE REAL ALGO is not just an EA provider — we are a full-stack <span className="text-white font-semibold">trading software development company</span>. Get your custom trading software built by experts.</p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 max-w-3xl mx-auto mt-10">
          <div className="glass-card rounded-2xl p-6 text-center">
            <p className="text-slate-400 text-sm">Custom Software Starting</p>
            <div className="font-display text-4xl font-bold text-blue-grad mt-1">$499</div>
            <p className="text-slate-500 text-xs mt-1">One-time project cost</p>
          </div>
          <div className="glass-card rounded-2xl p-6 text-center">
            <p className="text-slate-400 text-sm">Get Quote in</p>
            <div className="font-display text-4xl font-bold text-white mt-1">24 Hours</div>
            <p className="text-slate-500 text-xs mt-1">Free consultation</p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
          {BUILD_SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Code;
            return (
              <div key={i} className="reveal glass-card rounded-2xl p-6 hover:border-[rgba(46,155,255,0.5)] hover:-translate-y-1 transition-all duration-300">
                <div className="w-12 h-12 rounded-xl grid place-items-center bg-[rgba(46,155,255,0.12)] border border-[rgba(46,155,255,0.25)]">
                  <Icon className="w-6 h-6 text-[#2e9bff]" />
                </div>
                <h3 className="text-white font-semibold text-lg mt-5">{s.title}</h3>
                <p className="text-slate-400 text-sm mt-2 leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>

        <div className="grid lg:grid-cols-2 gap-6 mt-12">
          <div className="glass-card rounded-2xl p-8 reveal">
            <h3 className="text-white font-semibold text-xl">Why Choose THE REAL ALGO?</h3>
            <div className="grid sm:grid-cols-2 gap-3 mt-6">
              {BUILD_WHY.map((w) => (
                <div key={w} className="flex items-start gap-2.5 text-sm text-slate-300">
                  <CheckCircle2 className="w-5 h-5 text-[#22e39a] shrink-0 mt-0.5" /> {w}
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-2xl p-8 reveal relative overflow-hidden" style={{ background: "linear-gradient(135deg,#0c1830,#0a1120)", border: "1px solid rgba(46,155,255,0.25)" }}>
            <span className="text-[12px] tracking-widest text-[#2e9bff] font-semibold">Start Your Project Today</span>
            <h3 className="font-display text-3xl font-bold text-white mt-3">Get a <span className="text-blue-grad">Free Consultation</span></h3>
            <p className="text-slate-400 text-sm mt-3">Share your idea with us. We'll give you a free quote, timeline, and tech breakdown — all within 24 hours.</p>
            <div className="flex items-baseline gap-2 mt-5">
              <span className="font-display text-3xl font-bold text-white">$499</span>
              <span className="text-slate-400 text-sm">starting price for custom EA / software</span>
            </div>
            <div className="flex flex-wrap gap-3 mt-6">
              <a href={waLink(msg)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold bg-[#22e39a] text-[#04140c] hover:brightness-105 transition">
                <MessageCircle className="w-4 h-4" /> Chat on WhatsApp
              </a>
              <a href={BRAND.telegram} target="_blank" rel="noreferrer" className="btn-ghost inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold">
                <Send className="w-4 h-4" /> Join Telegram
              </a>
            </div>
            <p className="text-slate-400 text-sm mt-6">Have a trading idea? We'll turn it into <span className="text-white font-semibold">working software</span> — fast and affordable.</p>
            <a href={waLink(msg)} target="_blank" rel="noreferrer" className="btn-primary inline-flex items-center justify-center w-full mt-4 py-3.5 rounded-full font-semibold">
              Start Building Today — from $499
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
